/**
 * @generated SignedSource<<37ba1248f6de8485765a7fd4fbd02349>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_sku";
};
export type PdpRespSidebarBlurbShipping_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "0b39b2dde9ee83e734ff2726bfa413cd";

export default node;
